/**
 * Placeholder shown at the old Barometer route while VITE_FEATURE_HUGO is off.
 * Keeps bookmarks/links from 404ing and tells testers where the Barometer went.
 */
import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getAssistant } from '../assistants';

export default function ComingWithHugo() {
  const navigate = useNavigate();
  const hugo = getAssistant('hugo');
  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', mt: 4 }}>
      <Card variant="outlined">
        <CardContent sx={{ textAlign: 'center', py: 5 }}>
          <Box component="img" src={hugo.avatar} alt="HUGO" sx={{ width: 120, height: 120, mb: 1, opacity: 0.85 }} />
          <Typography variant="h5" fontWeight={800} gutterBottom>
            The Barometer is coming with HUGO
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            The Human Performance Barometer moves out of DREW and becomes the first page of HUGO —
            {' '}{hugo.shortTitle} — the next Intelligent Assistant to join REPSit.ai.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/drew')}>
            Back to DREW&rsquo;s OE Dashboard
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
